export const sx100PercentHeight = { height: "100%" };
export const sxPaperLiveActivityFeedContainer = { flex: 1, overflowY: "hidden", padding: "16px 8px" };
export const sxPaperLiveLeaderboardContainer = { flex: 1, overflowY: "hidden", padding: "8px 0" };
